/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Sign_CreditInputs */

const en_statement_taxonomy_editor_sign_credit = /** @type {(inputs: Statement_Taxonomy_Editor_Sign_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit (-1)`)
};

const nl_statement_taxonomy_editor_sign_credit = /** @type {(inputs: Statement_Taxonomy_Editor_Sign_CreditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit (-1)`)
};

/**
* | output |
* | --- |
* | "Credit (-1)" |
*
* @param {Statement_Taxonomy_Editor_Sign_CreditInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_sign_credit = /** @type {((inputs?: Statement_Taxonomy_Editor_Sign_CreditInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Sign_CreditInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_sign_credit(inputs)
	return en_statement_taxonomy_editor_sign_credit(inputs)
});